import { FormEvent, useState } from 'react';
import { Alert, Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import AuthController from '../../Api/authController';

const ResetPasswordPage = () => {
    const [params] = useSearchParams();
    const [password, setPassword] = useState('');
    const [repeat, setRepeat] = useState('');
    const [status, setStatus] = useState<{ ok: boolean; message: string } | null>(null);
    const [loading, setLoading] = useState(false);
    const submit = async (event: FormEvent) => {
        event.preventDefault();
        if (password !== repeat) return setStatus({ ok: false, message: 'Hasla nie sa identyczne' });
        setLoading(true);
        try { const res = await AuthController.resetPassword(params.get('token') || '', password); setStatus({ ok: true, message: res.data.message }); }
        catch (error: any) { setStatus({ ok: false, message: error?.response?.data?.message || 'Nie udalo sie zmienic hasla' }); }
        finally { setLoading(false); }
    };
    return <Box minHeight="100vh" display="grid" sx={{ placeItems: 'center', bgcolor: '#f4f6fb', p: 2 }}>
        <Paper component="form" onSubmit={submit} sx={{ p: 4, width: '100%', maxWidth: 440 }}><Stack spacing={2}>
            <Typography variant="h5" fontWeight={700}>Ustaw nowe haslo</Typography>
            <Typography color="text.secondary">Minimum 10 znakow, mala i wielka litera oraz cyfra.</Typography>
            {status && <Alert severity={status.ok ? 'success' : 'error'}>{status.message}</Alert>}
            {!status?.ok && <><TextField label="Nowe haslo" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <TextField label="Powtorz haslo" type="password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required />
            <Button type="submit" variant="contained" disabled={loading || !params.get('token')}>Zmien haslo</Button></>}
            <Button href="/logowanie">Przejdz do logowania</Button>
        </Stack></Paper>
    </Box>;
};
export default ResetPasswordPage;
